import makeStyles from '@mui/styles/makeStyles';
import {convertUrl} from "common/helpers";
import {isEmpty} from "lodash";
import React from "react";
import {color, font, match, radius, type} from "common/tokens";

const TONES = {
  active: {background: match.CHIP_BG, color: match.CHIP_FG},
  inactive: {background: match.CHIP_MUTED_BG, color: match.CHIP_MUTED_FG},
  clashing: {background: match.CHIP_CLASH_BG, color: match.CHIP_CLASH_FG},
};

const useStyles = makeStyles({
  criteria: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    borderRadius: radius.PILL,
    padding: '6px 10px',
    ...type.chip,
    fontWeight: font.MEDIUM,
  },
  icon: {
    height: 12,
    width: 12,
  },
});

const MatchCriteria = ({criteria, status, icon, onTint = false}) => {
  const classes = useStyles();
  const tone = TONES[status] || TONES.active;
  const background = onTint && tone === TONES.active ? color.SURFACE : tone.background;

  return (
    <span className={classes.criteria} style={{...tone, background}}>
      {!isEmpty(icon) && <img src={convertUrl(icon)} alt={''} className={classes.icon}/>}
      {criteria}
    </span>
  );
};

MatchCriteria.criteriaStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CLASHING: 'clashing',
};

export default MatchCriteria;
